import useTranslation from 'customHooks/translate';
import CurrencyFlag from 'react-currency-flags';

import { calculateSafePercent } from '../../../utils';

function ReportPartnerSummary({ title, summaryData }) {
  const translation = useTranslation();

  return (
    <div className="grid h-max grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-[10px] px-[16px] py-[16px] md:grid-cols-2 md:px-[32px]">
      <div className="flex h-full flex-col justify-between gap-[12px] rounded-[4px] bg-[#F5F7F9] p-[16px]">
        <p className="text-[18px] font-semibold text-[#1D1D1D]">{title}</p>
        {summaryData?.map((summary, index) => (
          <div
            className="flex gap-[4px] text-[16px] font-medium text-[#1D1D1D]"
            key={index}
          >
            <CurrencyFlag
              className="currency-flag"
              currency={summary.currency}
            />
            <span>
              {new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(summary.invoiceAmount)}
            </span>
            <span>{summary.currency}</span>
          </div>
        ))}
      </div>
      <div className="flex h-full flex-col justify-between gap-[12px] rounded-[4px] bg-[rgba(70,106,251,0.12)] p-[16px]">
        <p className="text-[18px] font-semibold text-[#1D1D1D]">
          {translation.reports.RemindAmount}
        </p>
        {summaryData?.map((summary, index) => {
          const safePercent = calculateSafePercent(
            summary.remainBalance,
            summary.invoiceAmount
          );

          return (
            <div key={index} className="flex flex-col gap-[6px]">
              <div className="flex flex-wrap gap-[6px] text-[16px] font-medium text-[#1D1D1D]">
                <CurrencyFlag
                  className="currency-flag"
                  currency={summary.currency}
                />
                <span>
                  {new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(summary.remainBalance)}
                </span>
                <span>{summary.currency}</span>
                <span className="ml-2 text-[#466AFB]">
                  ({safePercent?.toFixed(1)}%)
                </span>
              </div>

              <div className="h-2 w-full rounded bg-[#d2d9ff]">
                <div
                  className="h-full rounded bg-[#466AFB]"
                  style={{ width: `${safePercent}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ReportPartnerSummary;
